import { render, staticRenderFns } from "./trait_gene.vue?vue&type=template&id=5eead3c4&scoped=true&"
import script from "./trait_gene.vue?vue&type=script&lang=js&"
export * from "./trait_gene.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eead3c4",
  null
  
)

export default component.exports